export enum StockMobileStepperModule {
  CountStocktake = 'count-stocktake',
  Discrepancy = 'discrepancy',
  Wastage = 'wastage',
  Transfer = 'transfer',
}

export interface IStockMobileStepperConfig {
  totalSteps: number;
  nextRoutes: string[][];
}

export class StockMobileStepperConfigs {

  /**
   * Get stepper configuration for Count Stocktake module
   * Steps: 0 = Location Selection, 1 = Stock Groups Selection
   */
  public static getCountStocktakeConfig(): IStockMobileStepperConfig {
    return {
      totalSteps: 2,
      nextRoutes: [
        ['sysnet', 'stock-mobile', 'count-stocktake', 'create-select-stock-groups']
      ]
    };
  }

  /**
   * Get stepper configuration for Discrepancy module
   * Steps: 0 = Location Selection
   */
  public static getDiscrepancyConfig(): IStockMobileStepperConfig {
    return {
      totalSteps: 1,
      nextRoutes: []
    };
  }

  /**
   * Get stepper configuration for Wastage module
   * Steps: 0 = Location Selection
   */
  public static getWastageConfig(): IStockMobileStepperConfig {
    return {
      totalSteps: 1,
      nextRoutes: []
    };
  }

  /**
   * Get stepper configuration for Transfer module
   * Steps: 0 = Source Location Selection, 1 = Destination Location Selection
   */
  public static getTransferConfig(): IStockMobileStepperConfig {
    return {
      totalSteps: 2,
      nextRoutes: [
        // Step 0 (Source Location) -> Step 1 (Destination Location)
        ['sysnet', 'stock-mobile', 'transfer', 'create-select-destination-location']
      ]
    };
  }

  /**
   * Get configuration for a specific module
   */
  public static getModuleConfig(module: StockMobileStepperModule): IStockMobileStepperConfig {
    switch (module) {
      case StockMobileStepperModule.CountStocktake:
        return this.getCountStocktakeConfig();
      case StockMobileStepperModule.Discrepancy:
        return this.getDiscrepancyConfig();
      case StockMobileStepperModule.Wastage:
        return this.getWastageConfig();
      case StockMobileStepperModule.Transfer:
        return this.getTransferConfig();
      default:
        throw new Error(`Unknown stepper module: ${module}`);
    }
  }

  /**
   * Get all available modules
   */
  public static getAllModules(): StockMobileStepperModule[] {
    return Object.values(StockMobileStepperModule);
  }

  /**
   * Check if a module has multiple steps
   */
  public static hasMultipleSteps(module: StockMobileStepperModule): boolean {
    const config = this.getModuleConfig(module);
    return config.totalSteps > 1;
  }

  /**
   * Get next route for a specific module and step
   * Handles final step actions (save + navigate)
   */
  public static getNextRoute(module: StockMobileStepperModule, currentStep: number): string[] | null {
    const config = this.getModuleConfig(module);

    // Check if we have a regular next route for this step
    if (currentStep >= 0 && currentStep < config.nextRoutes.length) {
      return config.nextRoutes[currentStep];
    }

    return null;
  }

  public static isFinalStep(module: StockMobileStepperModule, currentStep: number): boolean {
    const config = this.getModuleConfig(module);
    return currentStep === config.totalSteps - 1;
  }
}
